import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t-4 border-foreground/20 bg-black text-white">
      <div className="mx-auto max-w-6xl px-6 py-10">
        <div className="grid gap-6 md:grid-cols-[auto,1fr] md:items-center">
          <div className="space-y-2">
            <div className="font-pixel text-[10px] uppercase tracking-wide text-accent crt-glow">
              {t("app.title")}
            </div>
            <div className="font-pixel text-[8px] text-white/50 uppercase tracking-widest">
              &copy; {currentYear}
              <span className="blink ml-1">_</span>
            </div>
          </div>

          <div className="text-sm text-white/60 md:text-right leading-relaxed">
            <p>{t("footer.disclaimer")}</p>
            <p className="mt-1">{t("footer.rights")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
